import type BaseEnumType from "@/app/services/baseEnumType";

export class EnumStopListItem implements BaseEnumType {
  private static allValues: EnumStopListItem[] = [];

  public static delivery = new EnumStopListItem(
    0,
    "delivery_app_delivery",
    "delivery_app_start_delivery",
    "delivery_app_edit_delivery",
    "delivery_app_complete_delivery",
    "delivery_app_unable_to_deliver"
  );
  public static visit = new EnumStopListItem(
    1,
    "delivery_app_visit",
    "delivery_app_start_visit",
    "delivery_app_edit_visit",
    "delivery_app_complete_visit",
    "delivery_app_unable_to_visit"
  );
  public static pickup = new EnumStopListItem(
    2,
    "delivery_app_pickup",
    "delivery_app_start_pickup",
    "delivery_app_edit_pickup",
    "delivery_app_complete_pickup",
    "delivery_app_unable_to_pickup"
  );

  public key: number;
  public value: string;
  public startKey: string;
  public editKey: string;
  public completeKey: string;
  public unableKey: string;

  private constructor(
    key: number,
    value: string,
    startKey: string,
    editKey: string,
    completeKey: string,
    unableKey: string
  ) {
    this.key = key;
    this.value = value;
    this.startKey = startKey;
    this.editKey = editKey;
    this.completeKey = completeKey;
    this.unableKey = unableKey;
    EnumStopListItem.allValues.push(this);
  }

  public static getValues(): EnumStopListItem[] {
    return EnumStopListItem.allValues;
  }

  public static getByKey(key: number): EnumStopListItem {
    const found = EnumStopListItem.allValues.find((e) => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumStopListItem - Key not found: ${key}`);
    }

    return found;
  }
}
